export const menuApi = async () => {
    try {
      const response = await fetch('appData/menu.json');
      const data = await response.json();
      return { menuResponse: data }; // data is now an array, not an object
    } catch (error) {
      console.error('Error fetching menu.json:', error);
      return { menuResponse: [] };
    }
  };
  